import { useNftx } from '@nftx/react';
import { Address, BadRequestError } from 'nftx.js';
import { useQuery } from '@tanstack/react-query';
import { QueryKey } from '../../queryKeys';

const useCollection = (collectionAddress: Address | undefined) => {
  const {
    network,
    core: { fetchCollection },
  } = useNftx();

  const enabled = !!collectionAddress;

  return useQuery(
    [QueryKey.COLLECTION, network, collectionAddress],
    () => {
      if (!collectionAddress) {
        throw new BadRequestError('collectionAddress is undefined');
      }
      return fetchCollection({ collectionAddress, network });
    },
    { enabled }
  );
};

export default useCollection;
